export default {
    JITSI: 'jitsi'
};
